import { useEffect, useRef, useState } from "react";
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist/legacy/build/pdf";
import { EventBus, TextLayerBuilder } from "pdfjs-dist/web/pdf_viewer";
import "pdfjs-dist/web/pdf_viewer.css";
import Tesseract from "tesseract.js";

GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

const PdfViewerWithSelect = ({ fileUrl, onSelectText }) => {
  const containerRef = useRef();
  const [zoom, setZoom] = useState(1.5); 

  useEffect(() => {
    if (!fileUrl) return;
    const container = containerRef.current;
    container.innerHTML = "";
    const eventBus = new EventBus();

    const renderPDF = async () => {
      const loadingTask = getDocument(fileUrl);
      const pdf = await loadingTask.promise;

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: zoom }); // ✅ acum zoom-ul funcționează dinamic

        const pageWrapper = document.createElement("div");
        pageWrapper.style.position = "relative";
        pageWrapper.style.width = `${viewport.width}px`;
        pageWrapper.style.height = `${viewport.height}px`;
        pageWrapper.style.margin = "20px auto";
        pageWrapper.style.backgroundColor = "white";
        container.appendChild(pageWrapper);

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        pageWrapper.appendChild(canvas);

        await page.render({ canvasContext: context, viewport }).promise;

        const textContent = await page.getTextContent();

        const extractedText = textContent.items.map(i => i.str).join("").trim();

        if (extractedText.length > 0 && !/[\u4e00-\u9faf]/.test(extractedText)) {
          // Are text normal, nu caractere chinezești
          const textLayerDiv = document.createElement("div");
          textLayerDiv.className = "textLayer";
          textLayerDiv.style.width = `${viewport.width}px`;
          textLayerDiv.style.height = `${viewport.height}px`;
          textLayerDiv.style.position = "absolute";
          textLayerDiv.style.top = "0";
          textLayerDiv.style.left = "0";
          textLayerDiv.style.userSelect = "text";
          textLayerDiv.style.pointerEvents = "auto";
          textLayerDiv.style.zIndex = "2";
          textLayerDiv.style.color = "transparent";
          pageWrapper.appendChild(textLayerDiv);

          const textLayer = new TextLayerBuilder({
            textLayerDiv,
            pageIndex: pageNum - 1,
            viewport,
            eventBus,
            enhanceTextSelection: true,
          });

          textLayer.setTextContent(textContent);
          await textLayer.render();

        } else {
          // Fallback la OCR
          const imageDataUrl = canvas.toDataURL("image/png");
          const ocrTextDiv = document.createElement("div");
          ocrTextDiv.style.position = "absolute";
          ocrTextDiv.style.top = "0";
          ocrTextDiv.style.left = "0";
          ocrTextDiv.style.width = `${viewport.width}px`;
          ocrTextDiv.style.height = `${viewport.height}px`;
          ocrTextDiv.style.padding = "10px";
          ocrTextDiv.style.whiteSpace = "pre-wrap";
          ocrTextDiv.style.color = "#000";
          ocrTextDiv.style.backgroundColor = "rgba(255,255,255,0.85)";
          ocrTextDiv.style.zIndex = "3";
          ocrTextDiv.style.fontSize = "14px";
          ocrTextDiv.style.overflowY = "auto";
          ocrTextDiv.textContent = "🔍 Scanning text...";
          pageWrapper.appendChild(ocrTextDiv);

          const result = await Tesseract.recognize(imageDataUrl, "eng", {
            logger: m => {
              if (m.status === "recognizing text") {
                console.log(`📖 OCR progress: ${(m.progress * 100).toFixed(1)}%`);
              }
            }
          });

          const ocrText = result.data.text.trim();
          if (ocrText) {
            ocrTextDiv.textContent = ocrText;
            if (onSelectText) onSelectText(ocrText);
          } else {
            ocrTextDiv.textContent = "[No text found]";
          }
        }
      }
    };

    renderPDF();

    return () => {
      container.innerHTML = "";
    };
  }, [fileUrl, zoom]); // ✅ re-randează PDF-ul la fiecare schimbare de zoom


  const handleMouseUp = () => {
    const selectedText = window.getSelection().toString().trim();
    if (selectedText) {
      onSelectText(selectedText);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      {/* 🔍 Zoom controls */}
      <div style={{ textAlign: "right", marginBottom: "10px" }}>
  <button onClick={() => setZoom((z) => Math.max(0.5, z - 0.2))} style={{ fontSize: "1.2rem", marginRight: "5px" }}>🔍➖</button>
  <button onClick={() => setZoom((z) => Math.min(3, z + 0.2))} style={{ fontSize: "1.2rem" }}>🔍➕</button>
  <span style={{ marginLeft: 10, fontSize: "1rem" }}>Zoom: {zoom.toFixed(1)}x</span>
</div>


      <div
        ref={containerRef}
        onMouseUp={handleMouseUp}
        style={{
          width: "100%",
          height: "1000px",
          overflowY: "auto",
          overflowX: "auto",
          backgroundColor: "#f0f0f0",
          padding: "10px",
          border: "1px solid #ccc"
        }}
      ></div>
    </div>
  );
};


export default PdfViewerWithSelect;
